import { Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';

import { Blog } from '../../../models/blog';
import { Works } from '../../../models/works';
import { UntypedFormControl } from '@angular/forms';
import { WorksService } from '../../../services/works.service';
import { ComuniService } from '../../../services/comuni.service';

import { MessageService, SelectItem } from "primeng/api";
import * as moment from 'moment';
import { Comuni } from 'src/app/models/comuni';
import { Tags } from 'src/app/models/tags';
import { TagsService } from 'src/app/services/tags.service';
import { TechnicalDataService } from 'src/app/services/technical_data.service';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { Card } from 'primeng/card';
import { InputText } from 'primeng/inputtext';

import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';

import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-technical-data-form',
    templateUrl: './technical-data-form.component.html',
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Card, InputText, Toast, TranslatePipe]
})
export class TechnicalDataFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private technicalDataService = inject(TechnicalDataService);
  private comuniService = inject(ComuniService);
  private messageService = inject(MessageService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  imagePath: any;
  tags: Tags;
  tag: Tags;
  readonly skillsValues = signal<any>([]);
  comuni: Comuni;

  checked: boolean = true;
  selectedValue: string;

  categoryForm: UntypedFormGroup;
  skillsValue: string;
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedWorks: Works;
  readonly selectedDate = signal<Date>(undefined);
  date: Date;
  readonly currentUser = signal<any>(undefined);

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }

    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));

  }

  ngOnInit() {

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {

      this.pageTitle.set('Modifica Dati technici');
      this.technicalDataService.getId(id).subscribe(
        res => {
          this.categoryForm.patchValue({
            name: res.name,
            description: res.description,
            type: res.type,
            skills: this.skillsValues(),
            user_id: this.currentUser().user_id,
            id: res.id
          });
        }
      );
    } else {
      this.pageTitle.set('Create Category');

    }

    this.categoryForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      description: [''],
      type: [''],
      skills: this.initSkill(),
      user_id: [this.currentUser().user_id],
    });
  }

  get name() {
    return this.categoryForm.get('name');
    return this.categoryForm.get('description');

  }

  initSkill() {
    var formArray = this.fb.array([]);
    const id = this.route.snapshot.paramMap.get("id");

    this.technicalDataService.skills(id).subscribe(
      (res)=>{
        this.skillsValues.set(res);

        this.skillsValues().forEach((e)=>{
          formArray.push(this.fb.group({
            price: [e.price]
          }))
        })
      }
    )

    return formArray;
  }

  private createSkillFormGroup(skill:any): UntypedFormGroup{
    return new UntypedFormGroup({'price':new UntypedFormControl(skill.price)})
  }

  public addSkill(skill:any){
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get skills() {
    return this.categoryForm.get('skills') as UntypedFormArray;
  }

  newQuantity(): UntypedFormGroup {
    return this.fb.group({
      price: "",
    })
  }

  addQuantity() {
    this.skills.push(this.newQuantity());
  }

  removeQuantity(i:number) {
    this.skills.removeAt(i);
  }

  onSubmit() {

    const formData = new FormData();

    formData.append('name', this.categoryForm.get('name').value);
    formData.append('description', this.categoryForm.get('description').value);
    formData.append('type', this.categoryForm.get('type').value);
    formData.append('skills', JSON.stringify(this.categoryForm.get('skills').value));
    formData.append('user_id', this.categoryForm.get('user_id').value);

    const id = this.categoryForm.get('id').value;

    if (id) {
      this.technicalDataService.update(formData, id).subscribe(
        res => {
          if (res.status == 'error') {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Salvato con sucesso' });
          }
        },
        error => this.error.set(error)
      );
    } else {
      this.technicalDataService.create(formData).subscribe(
        res => {
          if (res.status === 'error') {
            this.uploadError.set(res.message);
          } else {
            this.router.navigate(['/admin/settings/technical-data']);
          }
        },
        error => this.error.set(error)
      );
    }

  }

}
